export default __webpack_public_path__ + "a49199e0d982c05a0cc75e1966467544.png";